/* -------------------------------------------------------------------------- */
// Invoices
/* -------------------------------------------------------------------------- */

(function ($) {
  const init = function () {
    let invoicesPaymentForm = $('.invoice-item-payment form');
    let invoicePaymentAmount = $('.invoice-item-payment #paymentAmount');
    let invoicePaymentMethod = $('.invoice-item-payment #paymentMethod');
    let invoicePaymentMethodCancel = $('.invoice-item-payment .cancel');

    function invoicesCheckAmount() {
      $(invoicePaymentAmount).on('change', function () {
        const otherAmount = $(this).val();
        if (otherAmount.indexOf('other') >= 0) {
          $(this).closest('.field').next('.toggle-content').show();
        } else {
          $(this).closest('.field').next('.toggle-content').hide();
        }
      });
    }

    function invoicesCheckForm() {
      if ($(invoicesPaymentForm).length) {
        $(invoicesPaymentForm).each(function () {
          $.validator.setDefaults({ ignore: ':hidden:not(select)' });
          $(this).validate({
            highlight: function (element, errorClass, validClass) {
              $(element).closest('.field').addClass('error')
            },
            unhighlight: function(element, errorClass, validClass) {
              $(element).closest('.field').removeClass('error')
            }
            ,
            errorPlacement: function (error, element) {
              $(element).closest('.field').append(error);
            }
          });
        });
      }
    }

    function invoicesPaymentMethodDropdown() {
      if ($(invoicePaymentMethod).length) {
        $(invoicePaymentMethod).chosenImage({
          width: '100%',
          disable_search: true,
        });
      }
    }

    function invoicesPaymentAmountDropdown() {
      if ($(invoicePaymentAmount).length) {
        $(invoicePaymentAmount).chosen({ width: '100%', disable_search: true });
      }
    }

    function invoicePaymentCancel() {
      if ($(invoicePaymentMethodCancel).length) {
        $(invoicePaymentMethodCancel).on('click', function (e) {
          e.preventDefault();
          var input = $(this).closest('form').find('input:visible');
          var dropdown = $(this).closest('form').find('select');
          var toggle = $(this).closest('form').find('.toggle-content');

          input.val('');
          toggle.hide();
          dropdown.chosen('destroy');
          dropdown.prop('selectedIndex', -1);
          dropdown.chosen();
        });
      }
    }

    invoicesCheckAmount();
    invoicesCheckForm();
    invoicesPaymentMethodDropdown();
    invoicesPaymentAmountDropdown();
    invoicePaymentCancel();
  };
  $(init);
}(jQuery));
